import { render, staticRenderFns } from "./create-workpackage-dialog.vue?vue&type=template&id=e7745c0c&scoped=true"
import script from "./create-workpackage-dialog.vue?vue&type=script&lang=js"
export * from "./create-workpackage-dialog.vue?vue&type=script&lang=js"
import style0 from "./create-workpackage-dialog.vue?vue&type=style&index=0&id=e7745c0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7745c0c",
  null
  
)

export default component.exports